import { localeFormats } from '../i18n';

// Affichage d'une période à partir des dates de la sortie IA (déjà formatées en texte).
// joinRange('Janv. 2024', 'En cours') → 'Janv. 2024 – En cours' ; une seule présente → celle-ci.
export function joinRange(start: string, end: string): string {
  const s = start.trim();
  const e = end.trim();
  if (s && e) return `${s} – ${e}`;
  return s || e;
}

/**
 * Date d'AFFICHAGE — listes, profil, accueil. Suit la langue de l'INTERFACE, pas celle d'un
 * document : elle dit quand une chose a été enregistrée, elle ne fait partie d'aucun document.
 *
 * À ne pas confondre avec utils/letterDate, qui date l'en-tête d'une lettre et suit, lui, la
 * langue du document.
 *
 * '2026-06-10T12:00:00' → '10 juin 2026' en français, '10 Jun 2026' en anglais. Chaîne invalide → ''.
 */
export function formatSavedDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(localeFormats(), { day: 'numeric', month: 'short', year: 'numeric' }).format(d);
}
